import { AfterViewInit, Component } from '@angular/core';
import { version } from '../../environments/environment'
import { Router } from '@angular/router';
@Component({
  selector: 'app-default',
  standalone: false,
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss']
})
export class DefaultComponent implements AfterViewInit{
  constructor(private router: Router){

  }

  ngAfterViewInit(): void {
    let data = {"result":true,"message":"Success","response_object":"LINQ DASHBOARD - Version " + version ,"result_code":{"name":"Success","id":0}} ;
    let el = document.getElementById("jsonstring");
    if (el)
      el.textContent = JSON.stringify(data, undefined, 2);
  }

  public routerTest(){
    this.router.navigate(['/PipelineDashboard/12314']);
  }

}
